/**
 * Azure OpenAI Deployment Configuration
 * 
 * Defines deployment names for Azure OpenAI models.
 * Since Azure OpenAI calls are now made via edge functions,
 * frontend code only needs deployment names for configuration.
 */

/**
 * Azure OpenAI deployment names configuration
 * Byt här om distributionens namn ändras i Azure
 */
export const deployments = {
  mini: "gpt-5-mini",
  premium: "gpt-5-premium",      // Ny premium-distribution
  oldPremium: "gpt-4.1-premium", // Äldre premium-distribution (används i helpers.ts)
  support: "gpt-5-support",      // Support-distribution för AI-assistenten
  deterministicMini: "gpt-4o-mini" // Deterministisk mini-modell för skattekontoanalys
};

/**
 * NOTE: Environment variables are no longer accessed directly in the frontend.
 * Azure OpenAI calls are made via edge functions that have access to Supabase secrets.
 * This approach is more secure and follows Lovable best practices.
 */